module.exports = __webpack_public_path__ + "img/dashboard-web.20236f5b.png";